module.exports = __webpack_public_path__ + "static/media/Cotizador4.cabe9557.png";